var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1125_43799)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 7.5026L15.9751 4.42059C16.9017 3.33947 16.1336 1.66927 14.7096 1.66927L3.33334 1.66927L3.33334 13.3359L14.7096 13.3359C16.1336 13.3359 16.9017 11.6657 15.9751 10.5846L13.3333 7.5026ZM5.00001 11.6693L14.7096 11.6693L11.1382 7.5026L14.7096 3.33594L5.00001 3.33594L5.00001 11.6693Z",
    fill: "#777E91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 0.833334C3.33334 0.373096 3.70644 0 4.16668 0C4.62691 0 5.00001 0.373096 5.00001 0.833333L5.00001 19.1667C5.00001 19.6269 4.62691 20 4.16668 20C3.70644 20 3.33334 19.6269 3.33334 19.1667L3.33334 0.833334Z",
    fill: "#777E91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1125_43799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.3b3cc9bb733b302864ae69074a83611f.svg";
export { ForwardRef as ReactComponent };